import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import {
  getNotifications,
  getNotification,
  createNotification,
  sendWelcomeNotification,
} from "@/lib/api/notifications";
import { USER_QUERY_KEY } from "@/hooks/use-user";

interface UseNotificationsQueryOptions {
  refetchInterval?: number | false;
}

export const useNotificationsQuery = (options?: UseNotificationsQueryOptions) =>
  useQuery({
    queryKey: ["notifications"],
    queryFn: getNotifications,
    refetchInterval: options?.refetchInterval,
    refetchIntervalInBackground: false,
  });

export const useNotificationQuery = (id: string) =>
  useQuery({
    queryKey: ["notification", id],
    queryFn: () => getNotification(id).then((res) => res.data),
    enabled: !!id,
  });

export const useCreateNotificationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      // A first notification completes a Getting started step, which comes with the user.
      queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY });
    },
  });
};

export const useSendWelcomeNotificationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendWelcomeNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      // A first notification completes a Getting started step, which comes with the user.
      queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY });
    },
  });
};
